/** `/c/$companyId/purchases/suppliers/$contactId` — a supplier: details, other names, bank account. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { CODE_SETS } from "../ledger/books";
import { CodeGate } from "../shell/CodeGate";
import { SupplierScreen } from "../suppliers/SupplierScreen";

export const Route = createFileRoute("/_auth/c/$companyId/purchases/suppliers/$contactId")({
  component: SupplierRoute,
});

function SupplierRoute(): JSX.Element {
  const { companyId, contactId } = Route.useParams();
  return (
    <CodeGate companyId={companyId} codes={CODE_SETS.P}>
      <SupplierScreen companyId={companyId} contactId={contactId} />
    </CodeGate>
  );
}
